import React, { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { Container, Row, Col } from 'react-bootstrap'
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import CardPhone from 'components/molecules/CardPhone'
import LinkInternal from 'components/atoms/LinkInternal'
import CustomModal from 'components/molecules/CustomModal'
import ContactsAccordion from 'components/molecules/ContactsAccordion'
import get from 'lodash.get'

function PhoneTagsWithModal(props) {
  const [ modalOpen, setModalOpen ] = useState(false)
  const { data } = props
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const items = get(data, 'items')
  const modalLink = get(data, 'link')
  const categories = get(data, 'categories')

  return (
    <Container fluid="fluid" className="bg-white phone-tags-with-modal">
      <Container className="py-4">
        <Row className="mt-2 mt-md-3">
          <Col>
            <ContentBlock>
              <Typography
                variant="h2"
                color="purple"
                cssClass="title-bold-md"
              >
                { title }
              </Typography>
              
              { description &&
                <Typography
                  variant="span"
                  color="gray-100"
                  cssClass="bloco-conteudo-text mt-2 mb-3"
                >
                  { ReactHtmlParser(description) }
                </Typography>
              }
            </ContentBlock>
          </Col>
        </Row>
        <Row className="py-3 py-md-4">
          { Array.isArray(items) && items.filter(i => i.entity).map((item, index) => (
            <Col sm={12} md={3} key={get(item, 'entity.uuid')} className={index + 1 === get(data, 'items.length') ? "clear-height" : ""}>
              <CardPhone
                type="purple"
                icon={get(item, 'entity.icon.entity.media.entity.fieldMediaFile.entity.url')}
                description={get(item, 'entity.description.value')}
                maxLine={5}
                text={get(item, 'entity.text')}
              />
            </Col>
          ))}
        </Row>
        { modalLink &&
          <Row className="py-3 py-md-4">
            <Col>
              <LinkInternal
                title={get(modalLink, 'entity.link.title')}
                icon="arrow-right"
                iconAlign="right"
                color="primary"
                className="text-left"
                onClick={() => setModalOpen(true)}
              />

              <CustomModal
                open={modalOpen}
                closeModal={() => setModalOpen(false)}
                size="lg"
                title="Fale conosco"
              >
                <ContactsAccordion categories={categories} />
              </CustomModal>
            </Col>
          </Row>
        }
      </Container>
    </Container>
  )
}

export default PhoneTagsWithModal
